const appEnv = process.env.REACT_APP_ENV;

export const env = {
  isProduction: appEnv === 'prod',
  isTest: appEnv === 'test',
  isDevelopment: appEnv === 'dev',
  mediaUrl:
    appEnv === 'prov'
      ? 'https://provalliance-medias.s3.eu-west-3.amazonaws.com'
      : appEnv === 'stg'
      ? 'https://stg-provalliance-medias.s3.eu-west-3.amazonaws.com'
      : 'https://dev-provalliance-medias.s3.eu-west-3.amazonaws.com'
};
